// Единственное место в приложении с zustand (07-admin.md §1: "zustand только для auth"). Access-токен
// живёт только в памяти; `generation` растёт при смене субъекта (другой сотрудник вошёл) — providers.tsx
// сбрасывает по ней кэш TanStack Query.
import { create } from "zustand";
import type { AuthTokenResponse, Staff } from "@/shared/api/schemas/auth";

export type AuthStatus = "idle" | "loading" | "authenticated" | "unauthenticated";

interface AuthState {
  accessToken: string | null;
  expiresAt: number | null;
  staff: Staff | null;
  status: AuthStatus;
  generation: number;
  /** Причина, по которой сессия не восстановилась: бэкенд не ответил (а не «вы не входили»). */
  unavailable: boolean;
  setSession: (session: AuthTokenResponse) => void;
  clear: () => void;
  setStatus: (status: AuthStatus) => void;
  setUnavailable: (value: boolean) => void;
}

export const useAuthStore = create<AuthState>((set, get) => ({
  accessToken: null,
  expiresAt: null,
  staff: null,
  status: "idle",
  generation: 0,
  unavailable: false,
  setSession: (session) => {
    const prevStaffId = get().staff?.id;
    const changedSubject = prevStaffId !== undefined && prevStaffId !== session.staff.id;
    set((state) => ({
      accessToken: session.access_token,
      expiresAt: Date.now() + session.expires_in * 1000,
      staff: session.staff,
      status: "authenticated",
      unavailable: false,
      generation: changedSubject ? state.generation + 1 : state.generation,
    }));
  },
  // generation растёт и здесь: после logout staff становится null, поэтому setSession для СЛЕДУЮЩЕГО
  // входа (тем же или другим сотрудником) не отличит "первый вход" от "вход после выхода" и не увидит
  // смену субъекта — кэш Query предыдущего пользователя (черновики/ревизии/сессии/продукты) остался бы
  // навсегда (pre-merge review SHY-61, дефект 10). Логаут — безопасная граница, инвалидируем всегда.
  clear: () =>
    set((state) => ({
      accessToken: null,
      expiresAt: null,
      staff: null,
      status: "unauthenticated",
      generation: state.generation + 1,
    })),
  setStatus: (status) => set({ status }),
  setUnavailable: (value) => set({ unavailable: value }),
}));
